import React from 'react';
import './privacy.css';

function PrivacyAndPolicies() {
  return (
    <div className="privacy-container">
      <h1>Privacy & Policies</h1>

      <section className="policy-section">
        <h2>1. Introduction</h2>
        <p>
          Welcome to the <strong>Eye Care Digital Library</strong>. Your privacy is important to us, and we are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data.
        </p>
      </section>

      <section className="policy-section">
        <h2>2. Information We Collect</h2>
        <p>We may collect and process the following types of data:</p>
        <ul>
          <li><strong>Personal Information:</strong> Name, email, contact details (when you register or contact us).</li>
          <li><strong>Usage Data:</strong> Browsing activity, search history, and preferences.</li>
          <li><strong>Contributions:</strong> E-books, research articles, or other resources uploaded by users.</li>
        </ul>
      </section>

      <section className="policy-section">
        <h2>3. How We Use Your Information</h2>
        <p>We use your information for the following purposes:</p>
        <ul>
          <li>To provide and improve our digital library services.</li>
          <li>To personalize user experience and recommend relevant content.</li>
          <li>To ensure security and prevent unauthorized access.</li>
          <li>To communicate with users regarding updates, new features, or policy changes.</li>
          <li>To reward contributors with points that can be redeemed.</li>
        </ul>
      </section>

      <section className="policy-section">
        <h2>4. Data Protection & Security</h2>
        <p>
          We implement strict security measures to safeguard user data from unauthorized access, disclosure, or loss. However, users should also ensure safe browsing practices.
        </p>
      </section>

      <section className="policy-section">
        <h2>5. Third-Party Services</h2>
        <p>
          The Eye Care Digital Library may contain links to third-party websites or services (e.g., external research resources). We are not responsible for their privacy policies.
        </p>
      </section>

      <section className="policy-section">
        <h2>6. User Contributions & Rights</h2>
        <p>
          Users contributing resources (e-books, research papers, etc.) retain ownership but grant us a license to distribute and display their content. Users can request content removal if needed.
        </p>
      </section>

      <section className="policy-section">
        <h2>7. Contact & Support</h2>
        <p>
          If you have any questions regarding our privacy policies, please contact us at: <a href="mailto:eyecaredigitallibrary@gmail.com">eyecaredigitallibrary@gmail.com</a> or via our <a href="/contactus">Contact Us</a> page.
        </p>
      </section>

      <section className="policy-section">
        <h2>8. Changes to this Policy</h2>
        <p>
          We may update this Privacy Policy periodically. Users will be notified of significant changes. Continued use of our services constitutes acceptance of the revised policy.
        </p>
      </section>

    </div>
  );
}

export default PrivacyAndPolicies;
